import { ReactNode } from 'react';
import { Icon } from '@phosphor-icons/react';
import { DropdownMenuItem } from '@/components/DropdownMenu';
import { ActiveIndicator } from '../ActionBar.types';

interface ActionBarMenuItemProps {
    icon?: Icon;
    label: string;
    disabled?: boolean;
    isActive?: boolean;
    activeIndicator?: ActiveIndicator;
    onClick?: () => void;
    children?: ReactNode;
    alignOffset?: number;
    trailingBadge?: ReactNode;
    testId?: string;
}

export function ActionBarMenuItem(props: ActionBarMenuItemProps) {
    return <DropdownMenuItem {...props} />;
}
